export default __webpack_public_path__ + "static/media/camera.02e84da6.svg";